import React from 'react';
import useStyles from './ServiceWarrantyPage.styles';
import {FormattedMessage, useIntl} from 'react-intl';
import Title from 'components/Title';
import SupportMenu from 'components/SupportMenu';
import {useLocale} from 'context';
import NlPage from './translations/nl';
import EnPage from './translations/en';
import CallToAction from 'components/CallToAction';
import {Helmet} from 'react-helmet-async';

export default function () {
    let classes = useStyles();
    let {locale} = useLocale();
    let intl = useIntl();

    return (
        <div className={classes['root']}>
            <Helmet>
                <title>
                    {intl.formatMessage({
                        id: 'meta.SupportPage.ServiceWarrantyPage.title',
                    })}
                </title>
                <meta
                    name="description"
                    content={intl.formatMessage({
                        id: 'meta.SupportPage.ServiceWarrantyPage.description',
                    })}
                />
            </Helmet>
            <SupportMenu selected="serviceWarranty" />
            <Title
                title={
                    <FormattedMessage
                        id="pages.SupportPage.ServiceWarrantyPage.pageTitle"
                        defaultMessage={`Service & Warranty`}
                    />
                }
                subtitle={
                    <FormattedMessage
                        id="pages.SupportPage.ServiceWarrantyPage.pageSubtitle"
                        defaultMessage={`Customer Support`}
                    />
                }
            />
            {(locale === 'nl') ? (
                <NlPage />
            ) : (
                <EnPage />
            )}
            <div className={classes['__cta']}>
                <CallToAction
                    title={<FormattedMessage
                        id="pages.SupportPage.ctaTitle"
                        defaultMessage={`Another Question?`}
                    />}
                    text={<FormattedMessage
                        id="pages.SupportPage.ctaText"
                        defaultMessage={`Is your Question not listed? Don't hesitate to contact us!`}
                    />}
                    button={{
                        label: <FormattedMessage
                            id="pages.SupportPage.ctaButton"
                            defaultMessage={`Contact`}
                        />,
                        link: '/contact/',
                    }}
                />
            </div>
        </div>
    );
};
